import { FC } from 'react'
import { BannerContainer, BannerText } from './DemoAccountBanner.styles'
import EyeIcon from '@/assets/images/eye-icon.svg?react'

export const DemoAccountBanner: FC = () => (
    <BannerContainer data-testid="demo-account-banner">
        <EyeIcon width={24} height={25} />
        <BannerText variant="l-regular">
            Please note that you are in demo mode and have not yet registered
            for At-Bay&apos;s MDR solution.
        </BannerText>
    </BannerContainer>
)
